import { Helmet } from 'react-helmet-async';
import NonBrandedOverviewSection from 'src/sections/overview/dashboards/views/non-branded/views/search-terms';

export default function NonBrandedSearchPerformance() {
  return (
    <>
      <Helmet>
        <title>Search Performance</title>
      </Helmet>

      <NonBrandedOverviewSection />
    </>
  );
}
